import { useQuery } from "react-query"
import { getSalaryPaperHistory } from "api/Employee";
import { usePermissions } from "lib/hooks/shared/usePermissions";


export const useSalaryPaperHistory = (
    id: any
) => {
const permissions = usePermissions(['employee_management_view']);
return useQuery<Array<any> | any>(
  'salaryPaperHistory',
    () => getSalaryPaperHistory(permissions ? id : null),
    {
        onError(error: any) {
            console.error(error)
        }
    }
)
}